<template>
  <div class="fast-order-success">
    <div class="fast-order-success__icon">
      <SuccessIcon/>
    </div>

    <div class="fast-order-success__title texts texts_heading-18-15">
      Заказ оформлен
    </div>

    <div class="fast-order-success__subtitle texts texts_body">
      Вы успешно оставили заявку, ждите звонка нашего менеджера в ближайшее время
    </div>
  </div>
</template>

<script>
import SuccessIcon from "../icons/SuccessIcon";
export default {
  name: "TheFastOrderSuccess",
  components: {SuccessIcon},
}
</script>